/* src/app/admin-dashboard/announcement/announcement-card/announcement-form.component.css */
.mat-dialog-container {
  padding: 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.form-field {
  margin-bottom: 15px;
}
.form-field label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #555;
}
.form-field input,
.form-field textarea,
.form-field mat-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  transition: border-color 0.3s ease;
}
.form-field input:focus,
.form-field textarea:focus,
.form-field mat-select:focus {
  border-color: #007bff;
  outline: none;
}
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.mat-dialog-actions {
  margin-top: 20px;
}
.mat-dialog-actions button {
  margin-left: 10px;
}
/*# sourceMappingURL=announcement-form.component.css.map */
